export const BUSINESS_ROLE_VALUES = [
  "owner-director",
  "office-admin",
  "site-project-manager",
  "health-safety",
  "other",
] as const;

export const BUSINESS_ROLE_LABELS: Record<
  (typeof BUSINESS_ROLE_VALUES)[number],
  string
> = {
  "owner-director": "Owner or director",
  "office-admin": "Office or admin",
  "site-project-manager": "Site or project manager",
  "health-safety": "Health and safety",
  other: "Another role",
};

export const BUSINESS_TEAM_SIZE_VALUES = [
  "1-5",
  "6-10",
  "11-25",
  "26+",
] as const;

export const BUSINESS_TEAM_SIZE_LABELS: Record<
  (typeof BUSINESS_TEAM_SIZE_VALUES)[number],
  string
> = {
  "1-5": "1–5 people",
  "6-10": "6–10 people",
  "11-25": "11–25 people",
  "26+": "26+ people",
};

export const BUSINESS_PRIMARY_NEED_VALUES = [
  "site-inductions",
  "attendance",
  "site-files",
  "shared-paperwork",
  "subcontractor-records",
] as const;

export const BUSINESS_PRIMARY_NEED_LABELS: Record<
  (typeof BUSINESS_PRIMARY_NEED_VALUES)[number],
  string
> = {
  "site-inductions": "Site inductions and sign-offs",
  attendance: "Attendance and knowing who is on site",
  "site-files": "Site files and current information",
  "shared-paperwork": "RAMS, CPPs and shared paperwork",
  "subcontractor-records": "Subcontractor and worker records",
};

export const BUSINESS_BUYING_WINDOW_VALUES = [
  "now",
  "next-three-months",
  "researching",
] as const;

export const BUSINESS_BUYING_WINDOW_LABELS: Record<
  (typeof BUSINESS_BUYING_WINDOW_VALUES)[number],
  string
> = {
  now: "Now — we have an active need",
  "next-three-months": "Within the next three months",
  researching: "Researching for later",
};

export function businessWalkthroughOptionLabel(
  value: string | null | undefined,
  labels: Readonly<Record<string, string>>,
): string | null {
  if (!value) return null;
  return labels[value] ?? value;
}
